import axios from "axios";
import { Config } from "@reframe-mobile/config/env";

const TIMEOUT = 10_000;

export const httpClient = axios.create({
  baseURL: Config.API_URL,
  timeout: TIMEOUT,
  withCredentials: true,
});

// 응답 인터셉터: 401 시 로그인 페이지로 리다이렉트
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      const currentPath = window.location.pathname;
      if (currentPath !== "/login" && currentPath !== "/register") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);
